export const LANGUAGES = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

export const translations = {
  it: {
    localeTag: "it-IT",
    openNow: "Aperto ora",
    closed: "Chiuso",
    todayClosed: "Oggi chiuso",
    today: "Oggi",
    loadError: "Impossibile caricare le informazioni. Riprova.",
    ourMenu: "Il Nostro Menu",
    updatedOn: "Aggiornato il",
    loadingMenu: "Caricamento del menu…",
    menuComingTitle: "Menu in arrivo",
    menuComingText:
      "Il menu non è ancora stato caricato. Torna a trovarci a breve.",
    pdfErrorText: "Non riusciamo a mostrare il menu qui. Aprilo direttamente:",
    openPdf: "Apri il menu in PDF",
    downloadMenu: "Scarica il menu",
    daSapere: "Da sapere",
    reviewsTitle: "Lasciaci una recensione",
    reviewsSubtitle: "Il tuo parere ci aiuta a crescere. Grazie!",
    googleReview: "Recensione su Google",
    tripadvisorReview: "Recensione su Tripadvisor",
    call: "Chiama",
    map: "Mappa",
    // Gallery
    galleryTitle: "Galleria",
    gallerySubtitle: "Momenti al Giardino del Gusto",
    sharePhoto: "Condividi una foto",
    yourName: "Il tuo nome (facoltativo)",
    choosePhoto: "Scegli una foto",
    send: "Invia",
    sending: "Invio…",
    photoThanks:
      "Grazie! La tua foto sarà pubblicata dopo l'approvazione dello staff.",
    photoError: "Errore durante l'invio. Riprova.",
    galleryEmpty: "Sii il primo a condividere una foto!",
    cancel: "Annulla",
  },
  en: {
    localeTag: "en-GB",
    openNow: "Open now",
    closed: "Closed",
    todayClosed: "Closed today",
    today: "Today",
    loadError: "Unable to load the information. Please try again.",
    ourMenu: "Our Menu",
    updatedOn: "Updated on",
    loadingMenu: "Loading menu…",
    menuComingTitle: "Menu coming soon",
    menuComingText: "The menu hasn't been uploaded yet. Please check back soon.",
    pdfErrorText: "We can't show the menu here. Open it directly:",
    openPdf: "Open menu as PDF",
    downloadMenu: "Download menu",
    daSapere: "Good to know",
    reviewsTitle: "Leave us a review",
    reviewsSubtitle: "Your feedback helps us grow. Thank you!",
    googleReview: "Review on Google",
    tripadvisorReview: "Review on Tripadvisor",
    call: "Call",
    map: "Map",
    // Gallery
    galleryTitle: "Gallery",
    gallerySubtitle: "Moments at Giardino del Gusto",
    sharePhoto: "Share a photo",
    yourName: "Your name (optional)",
    choosePhoto: "Choose a photo",
    send: "Send",
    sending: "Sending…",
    photoThanks: "Thank you! Your photo will be published after staff approval.",
    photoError: "Something went wrong. Please try again.",
    galleryEmpty: "Be the first to share a photo!",
    cancel: "Cancel",
  },
};
